const WIDGET_SCRIPT_ID = 'twitter-wjs'
const WIDGET_SCRIPT_SRC = 'https://platform.twitter.com/widgets.js'

export interface CreateTweetOptions {
  conversation?: 'none' | 'all'
  align?: 'left' | 'center' | 'right'
  theme?: 'light' | 'dark'
}

export interface TwitterWidgets {
  createTweet(tweetId: string, target: HTMLElement, options?: CreateTweetOptions): Promise<HTMLElement | undefined>
}

interface Twttr {
  widgets: TwitterWidgets
  ready(callback: (twttr: Twttr) => void): void
}

declare global {
  interface Window {
    twttr?: Twttr
  }
}

let loadPromise: Promise<TwitterWidgets> | null = null

/**
 * widgets.js をロードし、`twttr.widgets` を解決する。
 */
export function loadTweetWidget(): Promise<TwitterWidgets> {
  if (window.twttr?.widgets) {
    return Promise.resolve(window.twttr.widgets)
  }

  if (loadPromise) {
    return loadPromise
  }

  loadPromise = new Promise<TwitterWidgets>((resolve, reject) => {
    const finalize = (): void => {
      if (window.twttr?.widgets) {
        window.twttr.ready(twttr => resolve(twttr.widgets))
      } else {
        reject(new Error('X ウィジェットの初期化に失敗しました。'))
      }
    }

    const existing = document.getElementById(WIDGET_SCRIPT_ID) as HTMLScriptElement | null
    if (existing) {
      existing.addEventListener('load', finalize)
      existing.addEventListener('error', () => reject(new Error('X ウィジェットのロードに失敗しました。')))
      if (window.twttr?.widgets) finalize()
      return
    }

    const script = document.createElement('script')
    script.id = WIDGET_SCRIPT_ID
    script.src = WIDGET_SCRIPT_SRC
    script.async = true
    script.addEventListener('load', finalize)
    script.addEventListener('error', () => reject(new Error('X ウィジェットのロードに失敗しました。')))
    document.head.appendChild(script)
  })

  loadPromise.catch(() => {
    loadPromise = null
  })

  return loadPromise
}
